import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "905551112233";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const currencySymbol = (c) => ({ eur: "€", usd: "$", try: "₺", gbp: "£" }[(c || "eur").toLowerCase()] || "€");

export const whatsappLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text || "Hello! I have a question about an Alanya activity.")}`;

export const logError = (...args) => {
  if (process.env.NODE_ENV === "development") console.error(...args);
};

export const PLACEHOLDER_IMG =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='400' height='300'><rect width='100%25' height='100%25' fill='%23e8eaf0'/><text x='50%25' y='50%25' font-family='sans-serif' font-size='20' fill='%239aa1b1' text-anchor='middle' dominant-baseline='middle'>No image</text></svg>";
